import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import PageHeader from '../helper/PageHeader';
import styles from '../styles';
import Loading from '../helper/Loading';
import { authContext } from "../../context/AuthContext";
import { SearchBarUserFirstLastRequired } from '../helper/SearchBars';
import SortedTable from '../helper/SortedTable';
import DeleteDialog from '../helper/Dialogs';
import Alert from '@mui/material/Alert';

// split the searchBar from the main component so that state updates to search fields would not lead to re-renders of the table
// this was an issue if the table had >200 rows, as it would have to re-render all those rows everytime the search changed

const AdminUsersSearch = props => {
    const { classes } = props
    const history = useHistory()
    const user = useContext(authContext)

    const [data, setData] = useState(null)
    const [originalLength, setOriginalLength] = useState(-1) // to display the truncation amount
    const [loading, setLoading] = useState(false)
    const mounted = useRef(true)
    const [deleteUser, setDeleteUser] = useState({open: false, id: null, error:null})

    const headCells = [
        { id: 'action', centered: false, sortable: false, label: 'Action' },
        { id: 'name', centered: false, sortable: true, label: 'Name' },
        { id: 'DOB', centered: false, sortable: true, label: 'DOB' },
        { id: 'CNAME', centered: false, sortable: true, label: 'Company Name' },
        { id: 'email', centered: false, sortable: true, label: 'Email' },
        { id: 'username', centered: false, sortable: true, label: 'Username' },
    ];

    const bodyCells = [
        { id: 'name', centered: false },
        { id: 'DOB', centered: false },
        { id: 'CNAME', centered: false },
        { id: 'email', centered: false },
        { id: 'username', centered: false },
    ];

    useEffect(() => {
       // on unmount
        if (window.sessionStorage.getItem("previousSearch")){
            setData( JSON.parse(window.sessionStorage.getItem("previousSearchData") ) );
        }
        return () => mounted.current = false
    },[])

    const onSearch = async (search) => {
        setLoading(true)
        const res = await axios.get("/api/user/adminSearch", {
            headers : {
                Authorization: user.accessToken
            },

            params: {
                username: search.username === '' ? null : search.username,
                firstName: search.firstName === '' ? null : search.firstName,
                lastName: search.lastName === '' ? null : search.lastName,
                email: search.email === '' ? null: search.email
            }
        })

        if (mounted.current) {
            const disableAction = user.roles.isRoleAdmin === 1? false:true;
            // grab the first 100
            const data = res.data.users.slice(0, 100).map(user => {
                user.id = user.username
                user.name = user.middle_name ? user.last_name + ", " + user.first_name + ' ' + user.middle_name : user.last_name + ", " + user.first_name
                user.CNAME = user.NAME 
                user.actionsDisabled = {
                    // only avaiable for role admin
                    allowPermission : disableAction ? false: true
                } 
                return user;
            })

            // console.log(data);
            setOriginalLength(res.data.users.length)
            
            setData(data)
            window.sessionStorage.setItem("previousSearch", true);
            window.sessionStorage.setItem("previousSearchData", JSON.stringify(data));
            setLoading(false)
        }

    }

    const clearSearch= () => {
        setData(null)
        window.sessionStorage.setItem('previousSearch', false)
        window.sessionStorage.removeItem('previousSearchData')
    }

    const addBackColor = id => {
        for(let i =0 ; i< data.length;i++){
            if(data[i].changed===true){
                data[i].changed = false;
            }
            if(data[i].id === id){
                data[i].changed = true;
            }
        }
        console.log('after changed', data);
        window.sessionStorage.setItem("previousSearchData", JSON.stringify(data));
    }

    const onPermissions = id => {
        console.log("ID is", id)

        addBackColor(id);

        history.push('/administration/users/roles/' + id)
    }

    const onProfile = id => {
        console.log("ID is", id)
        
        addBackColor(id);

        history.push({
            pathname: '/administration/users/' + id//,
            // state: {
            //     byAdmin: true,
            // },
        })
    }

    const onHist = id => {
        console.log("ID is", id)
        addBackColor(id);
        history.push('/administration/users/' + id + '/trainingHistory')
    }


    const onPurchaseTransaction = id => {
        console.log("ID is", id)
        
        addBackColor(id);

        history.push({
            pathname: '/administration/userPurchase/user/' + id,
        })
    }

    const onProfileLog = id => {
        console.log("ID is", id)
        
        addBackColor(id);

        history.push({
            pathname: '/administration/userLog/' + id,
        })
    }

    const onCredit = id => {
        console.log("ID is", id)
        
        addBackColor(id);

        history.push({
            pathname: '/administration/userCredit/' + id,
        })
    }

    
    // closes dialog
    const onDeleteUserDialogClose = () => {
        setDeleteUser({open: false, id: null})
    }

    // submits credit additions and reload
    const handleDeleteUser = async () => {

        try {
            await axios('/api/user/' + deleteUser.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': user.accessToken
                }
            })
            clearSearch()
        } catch (error) {
            //console.log(error)
            setDeleteUser({...deleteUser, error: error.message})
        }
        onDeleteUserDialogClose()
    }
    const onDeleteUser = id => {
        
        //addBackColor(id);
        setDeleteUser({open: true, id: id})
    }
    const actionButtons = [
        { icon: "lock", label: "Permissions", action: onPermissions, delete: false, view: "allowPermission"  },
        { icon: "profile", label: "Profile", action: onProfile, delete: false },
        { icon: "log", label: "Profile Log", action: onProfileLog, delete: false },
        { icon: "quiz", label: "Training History", action: onHist, delete: false },
        { icon: "credit", label: "Purchase History", action: onCredit, delete: false },
        { icon: "purchase", label: "Payments", action: onPurchaseTransaction, delete: false },
        { icon: "delete", label: "Delete", action: onDeleteUser, delete: true },

    ];

    const editDelete = false;

    return (
        <>
            <PageHeader
                title={"Search Users (admin)"}
            />
            <SearchBarUserFirstLastRequired classes={classes} onSearch={onSearch} clearSearch={clearSearch}/>

            <br /><br />
            {deleteUser.error &&
                <Alert severity="error" >{deleteUser.error}</Alert>
            }

            {loading ? <Loading /> : // if loading display message
                data === null ?
                    null : // if there is no data display nothing
                    data.length === 0 // if there is data but it is empty
                        ?
                        <Box display="flex" mt={4} justifyContent="center">
                            <h1>No Data</h1>
                        </Box>
                        :
                        <>
                            {originalLength > 100 && <p>{`Found too many results (${originalLength}) limiting results to 100`}</p>}
                            <SortedTable
                                data={data}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey="name"
                                cellKey={"id"}
                                // cellKey={"Trainee_ID"}
                                editDelete={editDelete}
                                actionButtons={actionButtons}
                                actions={true}
                                highlight="changed"
                            />
                             <DeleteDialog
                                open={deleteUser.open}
                                onClose={() => setDeleteUser({open: false, id: null})}
                                onDelete={() => handleDeleteUser()}
                            />
                        </>
            }
        </>
    )
}

export default withStyles(styles, { withTheme: true })(AdminUsersSearch)